/* eslint-disable import/no-duplicates */

import getParameterFromURL from '../utils/scripts/getParameterFromURL';
import store from '../store';

import iconPuppy from './img/optionsImages/puppy.png';
import iconAdult from './img/optionsImages/adult.png';
import iconPoodle from './img/optionsImages/poodle.png';
import iconChick from './img/optionsImages/chick.png';
import iconBone from './img/optionsImages/bone.png';
import iconHeart from './img/optionsImages/heart.png';
import iconBall from './img/optionsImages/ball.png';
import iconOther from './img/optionsImages/other.png';
import iconSmile from './img/optionsImages/iconSmile.png';
import iconSurprised from './img/optionsImages/iconSurprised.png';
import iconPensive from './img/optionsImages/iconPensive.png';
import iconLabrador from './img/optionsImages/labrador.png';
import iconPaws from './img/optionsImages/iconPaws.png';
import iconDown from './img/optionsImages/iconDown.png';
import iconUpset from './img/optionsImages/iconUpset.png';
import iconCross from './img/optionsImages/cross.png';
import iconDontKnow from './img/optionsImages/iconDontKnow.png';
import iconDarkDog from './img/optionsImages/iconDarkDog.png';

import iconYes from './img/optionsImages/yes.png';
import iconSoso from './img/optionsImages/so-so.png';
import iconNo from './img/optionsImages/no.png';

import iconBeingHomeAloneV1 from './img/optionsImages/house.png';
import iconBeingHomeAloneV2 from './img/optionsImages/calendar.png';
import iconBeingHomeAloneV3 from './img/optionsImages/calendar2.png';
import iconBeingHomeAloneV4 from './img/optionsImages/dog.png';

import iconYesV1 from './img/optionsImages/yes.png';
import iconNoV2 from './img/optionsImages/no.png';

// import customV1ConcernV1 from './img/optionsImages/dog1.png';
// import customV1ConcernV2 from './img/optionsImages/dog2.png';
// import customV1ConcernV3 from './img/optionsImages/dog3.png';
// import customV1ConcernV4 from './img/optionsImages/dog4.png';
// import customV1ConcernV5 from './img/optionsImages/dog5.png';
// import customV1ConcernV6 from './img/optionsImages/dog6.png';

import addImgAge from './img/optionsImages/addImg_age.jpg';
import addImgJumping from './img/optionsImages/addImg_jumping.jpg';
import addImgObedience from './img/optionsImages/addImg_obedience.jpg';
import addImgPickingUp from './img/optionsImages/addImg_picking_up.jpg';
import addImgBeingForFood from './img/optionsImages/addImg_being_for_food.jpg';
import addImgPuppyOrAdult from './img/optionsImages/addImg_puppy_or_adult.jpg';
import addImgHowOld from './img/optionsImages/addImg_how_old.jpg';
import addImgBreed from './img/optionsImages/addImg_breed.jpg';
import addImgBeingHome from './img/optionsImages/addImg_being_home.jpg';
import addImgBiting from './img/optionsImages/addImg_biting.jpg';
import addImgChewing from './img/optionsImages/addImg_chewing.jpg';
import addImgHygiene from './img/optionsImages/addImg_hygiene.jpg';
import addImgPottyTraining from './img/optionsImages/addImg_potty_training.jpg';

import iconGenderGirl from './img/optionsImages/customV1girl.svg';
import iconGenderBoy from './img/optionsImages/customV1boy.svg';

import iconGenderGirlV2 from './img/optionsImages/customV2girl.svg';
import iconGenderBoyV2 from './img/optionsImages/customV2boy.svg';

import iconGenderGirlV3 from './img/optionsImages/customV2girl.png';
import iconGenderBoyV3 from './img/optionsImages/customV2boy.png';

import iconHealthV1 from './img/optionsImages/customV2IconHealthV1.svg';
import iconHealthV2 from './img/optionsImages/customV2IconHealthV2.svg';
import iconHealthV3 from './img/optionsImages/customV2IconHealthV3.svg';
import iconHealthV4 from './img/optionsImages/customV2IconHealthV4.svg';
import iconHealthV5 from './img/optionsImages/customV2IconHealthV5.svg';

import iconPottyV1 from './img/optionsImages/customV2PottyV1.svg';
import iconPottyV2 from './img/optionsImages/customV2PottyV2.svg';
import iconPottyV3 from './img/optionsImages/customV2PottyV3.svg';
import iconPottyV4 from './img/optionsImages/customV2PottyV4.svg';
import iconPottyV5 from './img/optionsImages/customV2PottyV5.svg';
import iconPottyV6 from './img/optionsImages/customV2PottyV6.svg';

import iconPottyV7 from './img/optionsImages/customV2PottyV7.svg';
import iconPottyV8 from './img/optionsImages/customV2PottyV8.svg';
import iconPottyV9 from './img/optionsImages/customV2PottyV9.svg';
import iconPottyV10 from './img/optionsImages/customV2PottyV10.svg';

import iconIssuesV1 from './img/optionsImages/customV2IssuesV1.svg';
import iconIssuesV2 from './img/optionsImages/customV2IssuesV2.svg';
import iconIssuesV3 from './img/optionsImages/customV2IssuesV3.svg';
import iconIssuesV4 from './img/optionsImages/customV2IssuesV4.svg';
import iconIssuesV5 from './img/optionsImages/customV2IssuesV5.svg';

import iconIssues2V1 from './img/optionsImages/customV2Issues2V1.svg';
import iconIssues2V2 from './img/optionsImages/customV2Issues2V2.svg';
import iconIssues2V3 from './img/optionsImages/customV2Issues2V3.svg';
import iconIssues2V4 from './img/optionsImages/customV2Issues2V4.svg';
import iconIssues2V5 from './img/optionsImages/customV2Issues2V5.svg';
import iconIssues2V6 from './img/optionsImages/customV2Issues2V6.svg';

import iconWalkingIssuesV1 from './img/optionsImages/customV2WalkingIssuesV1.svg';
import iconWalkingIssuesV2 from './img/optionsImages/customV2WalkingIssuesV2.svg';
import iconWalkingIssuesV3 from './img/optionsImages/customV2WalkingIssuesV3.svg';
import iconWalkingIssuesV4 from './img/optionsImages/customV2WalkingIssuesV4.svg';
import iconWalkingIssuesV5 from './img/optionsImages/customV2WalkingIssuesV5.svg';

import iconActivityV1 from './img/optionsImages/customV2ActivityV1.svg';
import iconActivityV2 from './img/optionsImages/customV2ActivityV2.svg';
import iconActivityV3 from './img/optionsImages/customV2ActivityV3.svg';
import customV2DrinkingV1 from './img/optionsImages/customV2DrinkingV1.svg';
import customV2DrinkingV2 from './img/optionsImages/customV2DrinkingV2.svg';
import customV2DrinkingV3 from './img/optionsImages/customV2DrinkingV3.svg';
import customV2DrinkingV4 from './img/optionsImages/customV2DrinkingV4.svg';
import customV2HealthAlert from './img/optionsImages/customV2HealthAlert.svg';
import customV2HealthEye from './img/optionsImages/customV2HealthEye.svg';
import customV2HealthHandOk from './img/optionsImages/customV2HealthHandOk.svg';
import customV2HealthMoon from './img/optionsImages/customV2HealthMoon.svg';
import customV2HealthStackedBox from './img/optionsImages/customV2HealthStackedBox.svg';
import customV2HealthSymptoms from './img/optionsImages/customV2HealthSymptoms.svg';
import customV2HealthUnsure from './img/optionsImages/customV2HealthUnsure.svg';
import customV2FoodTypeV1 from './img/optionsImages/customV2FoodTypeV1.png';
import customV2FoodTypeV2 from './img/optionsImages/customV2FoodTypeV2.png';
import customV2FoodTypeV3 from './img/optionsImages/customV2FoodTypeV3.png';
import customV2FoodTypeV4 from './img/optionsImages/customV2FoodTypeV4.png';
import customV2FoodAllergiesV1 from './img/optionsImages/customV2FoodAllergiesV1.png';
import customV2FoodAllergiesV2 from './img/optionsImages/customV2FoodAllergiesV2.png';
import customV2FoodAllergiesV3 from './img/optionsImages/customV2FoodAllergiesV3.png';
import customV2FoodAllergiesV4 from './img/optionsImages/customV2FoodAllergiesV4.png';
import customV2HealthGoalsV1 from './img/optionsImages/customV2HealthGoalsV1.png';
import customV2HealthGoalsV2 from './img/optionsImages/customV2HealthGoalsV2.png';
import customV2HealthGoalsV3 from './img/optionsImages/customV2HealthGoalsV3.png';
import customV2HealthGoalsV4 from './img/optionsImages/customV2HealthGoalsV4.png';
import customV2FoodChoiceV1 from './img/optionsImages/customV2FoodChoiceV1.png';
import customV2FoodChoiceV2 from './img/optionsImages/customV2FoodChoiceV2.png';
import customV2FoodChoiceV3 from './img/optionsImages/customV2FoodChoiceV3.png';
import customV2FoodChoiceV4 from './img/optionsImages/customV2FoodChoiceV4.png';

import iconTrainingV1 from './img/optionsImages/customV2TrainingV1.svg';
import iconTrainingV2 from './img/optionsImages/customV2TrainingV2.svg';
import iconTrainingV3 from './img/optionsImages/customV2TrainingV3.svg';

// import iconCreatingProgramV1 from './img/optionsImages/customV2CreatingProgramV1.svg';
// import iconCreatingProgramV2 from './img/optionsImages/customV2CreatingProgramV2.svg';
// import iconCreatingProgramV3 from './img/optionsImages/customV2CreatingProgramV3.svg';
// import iconCreatingProgramV4 from './img/optionsImages/customV2CreatingProgramV4.svg';

import iconCreatingProgramV5 from './img/optionsImages/customV2CreatingProgramV5.svg';
import iconCreatingProgramV6 from './img/optionsImages/customV2CreatingProgramV6.svg';
import iconCreatingProgramV7 from './img/optionsImages/customV2CreatingProgramV7.svg';
import iconCreatingProgramV8 from './img/optionsImages/customV2CreatingProgramV8.svg';

import behaviorProblemV1 from './img/optionsImages/customV4BehaviorProblemV1.jpg';
import behaviorProblemV2 from './img/optionsImages/customV4BehaviorProblemV2.jpg';
import behaviorProblemV3 from './img/optionsImages/customV4BehaviorProblemV3.jpg';
import behaviorProblemV4 from './img/optionsImages/customV4BehaviorProblemV4.jpg';

import behaviorProblemV5 from './img/optionsImages/customV4BehaviorProblemV5.jpg';
import behaviorProblemV6 from './img/optionsImages/customV4BehaviorProblemV6.jpg';
import behaviorProblemV7 from './img/optionsImages/customV4BehaviorProblemV7.jpg';
import behaviorProblemV8 from './img/optionsImages/customV4BehaviorProblemV8.jpg';

import behaviorV1 from './img/optionsImages/behaviorV1.png';
import behaviorV2 from './img/optionsImages/behaviorV2.png';
import behaviorV3 from './img/optionsImages/behaviorV3.png';
import behaviorV4 from './img/optionsImages/behaviorV4.png';
import behaviorV5 from './img/optionsImages/behaviorV5.png';
import behaviorV6 from './img/optionsImages/behaviorV6.png';
import behaviorV7 from './img/optionsImages/behaviorV7.png';

import customV2ageV1 from './img/optionsImages/customV2ageV1.jpg';
import customV2ageV2 from './img/optionsImages/customV2ageV2.jpg';
import customV2ageV3 from './img/optionsImages/customV2ageV3.jpg';
import customV2ageV4 from './img/optionsImages/customV2ageV4.jpg';
import customV2ageV5 from './img/optionsImages/customV2ageV5.jpg';
import customV2ageV6 from './img/optionsImages/customV2ageV6.jpg';

import customV2reasonV1 from './img/optionsImages/reason1.png';
import customV2reasonV2 from './img/optionsImages/reason2.png';
import customV2reasonV3 from './img/optionsImages/reason3.png';
import customV2reasonV4 from './img/optionsImages/reason4.png';
import customV2reasonV5 from './img/optionsImages/reason5.png';
import customV2reasonV6 from './img/optionsImages/reason6.png';
import customV2reasonV7 from './img/optionsImages/reason7.png';
import customV2reasonV8 from './img/optionsImages/reason8.png';

import foodV1 from './img/optionsImages/foodV1.png';
import foodV2 from './img/optionsImages/foodV2.png';
import foodV3 from './img/optionsImages/foodV3.png';
import foodV4 from './img/optionsImages/foodV4.png';

import issuesBitingV1 from './img/optionsImages/issuesBitingV1.png';
import issuesBitingV2 from './img/optionsImages/issuesBitingV2.png';

import issuesDamageV1 from './img/optionsImages/issuesDamageV1.png';
import issuesDamageV2 from './img/optionsImages/issuesDamageV2.png';

import issuesCrateV1 from './img/optionsImages/issuesCrateV1.png';
import issuesCrateV2 from './img/optionsImages/issuesCrateV2.png';

import issuesHomeV1 from './img/optionsImages/issuesHomeV1.png';
import issuesHomeV2 from './img/optionsImages/issuesHomeV2.png';
import issuesHomeV3 from './img/optionsImages/issuesHomeV3.png';
import issuesHomeV4 from './img/optionsImages/issuesHomeV4.png';

import followCommandsV1 from './img/optionsImages/followCommandsV1.png';
import followCommandsV2 from './img/optionsImages/followCommandsV2.png';
import followCommandsV3 from './img/optionsImages/followCommandsV3.png';
import followCommandsV4 from './img/optionsImages/followCommandsV4.png';

import raiseVoiceV1 from './img/optionsImages/raiseVoiceV1.png';
import raiseVoiceV2 from './img/optionsImages/raiseVoiceV2.png';
import raiseVoiceV3 from './img/optionsImages/raiseVoiceV3.png';
import raiseVoiceV4 from './img/optionsImages/raiseVoiceV4.png';

import hitDogV1 from './img/optionsImages/hitDogV1.png';
import hitDogV2 from './img/optionsImages/hitDogV2.png';

import howAttachedV1 from './img/optionsImages/howAttachedV1.png';
import howAttachedV2 from './img/optionsImages/howAttachedV2.png';
import howAttachedV3 from './img/optionsImages/howAttachedV3.png';

import ownerFeelingsV1 from './img/optionsImages/ownerFeelingsV1.svg';
import ownerFeelingsV2 from './img/optionsImages/ownerFeelingsV2.svg';
import ownerFeelingsV3 from './img/optionsImages/ownerFeelingsV3.svg';
import ownerFeelingsV4 from './img/optionsImages/ownerFeelingsV4.svg';

import ownerSleepV1 from './img/optionsImages/ownerSleepV1.svg';
import ownerSleepV2 from './img/optionsImages/ownerSleepV2.svg';
import ownerSleepV3 from './img/optionsImages/ownerSleepV3.svg';
import ownerSleepV4 from './img/optionsImages/ownerSleepV4.svg';

import ownerPuppyAffectV1 from './img/optionsImages/ownerPuppyAffectV1.svg';
import ownerPuppyAffectV2 from './img/optionsImages/ownerPuppyAffectV2.svg';
import ownerPuppyAffectV3 from './img/optionsImages/ownerPuppyAffectV3.svg';
import ownerPuppyAffectV4 from './img/optionsImages/ownerPuppyAffectV4.svg';

import ownerSupportV1 from './img/optionsImages/ownerSupportV1.svg';
import ownerSupportV2 from './img/optionsImages/ownerSupportV2.svg';
import ownerSupportV3 from './img/optionsImages/ownerSupportV3.svg';
import ownerSupportV4 from './img/optionsImages/ownerSupportV4.svg';

import ownerConcernsV1 from './img/optionsImages/ownerConcernsV1.svg';
import ownerConcernsV2 from './img/optionsImages/ownerConcernsV2.svg';
import ownerConcernsV3 from './img/optionsImages/ownerConcernsV3.svg';
import ownerConcernsV4 from './img/optionsImages/ownerConcernsV4.svg';
import ownerConcernsV5 from './img/optionsImages/ownerConcernsV5.svg';

import pottyHowLongV1 from './img/optionsImages/pottyHowLong.png';
import pottyHowLongV2 from './img/optionsImages/pottyHowLongV2.png';

import pottyWhereV1 from './img/optionsImages/pottyWhereV1.png';

import pottyHowOftenWalksV1 from './img/optionsImages/pottyHowOftenWalksV1.png';

import pottyHealthIssuesV1 from './img/optionsImages/pottyHealthIssuesV1.svg';
import pottyHealthIssuesV2 from './img/optionsImages/pottyHealthIssuesV2.svg';
import pottyHealthIssuesV3 from './img/optionsImages/pottyHealthIssuesV3.svg';
import pottyHealthIssuesV4 from './img/optionsImages/pottyHealthIssuesV4.svg';

import pottyWhereWantV1 from './img/optionsImages/pottyWhereWantV1.svg';
import pottyWhereWantV2 from './img/optionsImages/pottyWhereWantV2.svg';
import pottyWhereWantV3 from './img/optionsImages/pottyWhereWantV3.svg';

import trainingRaiseVoiceV1 from './img/optionsImages/trainingRaiseVoiceV1.svg';
import trainingRaiseVoiceV2 from './img/optionsImages/trainingRaiseVoiceV2.svg';
import trainingRaiseVoiceV3 from './img/optionsImages/trainingRaiseVoiceV3.svg';
import trainingRaiseVoiceV4 from './img/optionsImages/trainingRaiseVoiceV4.svg';

import trainingReactToPunishmentV1 from './img/optionsImages/trainingReactToPunishmentV1.svg';
import trainingReactToPunishmentV2 from './img/optionsImages/trainingReactToPunishmentV2.svg';
import trainingReactToPunishmentV3 from './img/optionsImages/trainingReactToPunishmentV3.svg';
import trainingReactToPunishmentV4 from './img/optionsImages/trainingReactToPunishmentV4.svg';

import statementIrritationV1 from './img/optionsImages/statementIrritationV1.png';
import statementIrritationV1Dark from './img/optionsImages/statementIrritationV1Dark.jpg';
import statementIgnoreCommandsV1 from './img/optionsImages/statementIgnoreCommandsV1.png';
import statementIgnoreCommandsV1Dark from './img/optionsImages/statementIgnoreCommandsV1Dark.jpg';
import statementStrongBondV1 from './img/optionsImages/statementStrongBondV1.png';
import statementStrongBondV1Dark from './img/optionsImages/statementStrongBondV1Dark.jpg';

import healthUncertainty from './img/optionsImages/health_uncertainty.png';

import mainGoalV1 from './img/optionsImages/mainGoalV1.png';
import mainGoalV2 from './img/optionsImages/mainGoalV2.png';
import mainGoalV3 from './img/optionsImages/mainGoalV3.png';
import mainGoalV4 from './img/optionsImages/mainGoalV4.png';
import mainGoalV5 from './img/optionsImages/mainGoalV5.png';

import zwGirl from './img/optionsImages/zwGirl.png';
import zwBoy from './img/optionsImages/zwBoy.png';

import wo1 from './img/optionsImages/wo1.png';
import wo2 from './img/optionsImages/wo2.png';
import wo3 from './img/optionsImages/wo3.png';
import wo4 from './img/optionsImages/wo4.png';
import wo5 from './img/optionsImages/wo5.png';

import startPageAgeV1 from './img/optionsImages/startPageAgeV1.png';
import startPageAgeV2 from './img/optionsImages/startPageAgeV2.png';
import startPageAgeV3 from './img/optionsImages/startPageAgeV3.png';
import startPageAgeV4 from './img/optionsImages/startPageAgeV4.png';
import startPageAgeV1Vet from './img/optionsImages/startPageAgeV1Vet.png';
import startPageAgeV2Vet from './img/optionsImages/startPageAgeV2Vet.png';
import startPageAgeV3Vet from './img/optionsImages/startPageAgeV3Vet.png';
import startPageAgeV4Vet from './img/optionsImages/startPageAgeV4Vet.png';

import startPageAgeV2V1 from './img/optionsImages/startPageAgeV2V1.png';
import startPageAgeV2V2 from './img/optionsImages/startPageAgeV2V2.png';
import startPageAgeV2V3 from './img/optionsImages/startPageAgeV2V3.png';
import startPageAgeV2V4 from './img/optionsImages/startPageAgeV2V4.png';

import startPageAgeV3V1 from './img/optionsImages/startPageAgeV3V1.png';
import startPageAgeV3V2 from './img/optionsImages/startPageAgeV3V2.png';
import startPageAgeV3V3 from './img/optionsImages/startPageAgeV3V3.png';
import startPageAgeV3V4 from './img/optionsImages/startPageAgeV3V4.png';

import startPageAgeV1Ilustr from './img/optionsImages/startPageAgeV1Ilustr.png';
import startPageAgeV2Ilustr from './img/optionsImages/startPageAgeV2Ilustr.png';
import startPageAgeV3Ilustr from './img/optionsImages/startPageAgeV3Ilustr.png';
import startPageAgeV4Ilustr from './img/optionsImages/startPageAgeV4Ilustr.png';

import trainingTimeV1 from './img/optionsImages/trainingTimeV1.png';
import trainingTimeV2 from './img/optionsImages/trainingTimeV2.png';
import trainingTimeV3 from './img/optionsImages/trainingTimeV3.png';
import trainingTimeV4 from './img/optionsImages/trainingTimeV4.png';

import crateTrainedV1 from './img/optionsImages/crateTrainedV1.png';
import crateTrainedV2 from './img/optionsImages/crateTrainedV2.png';
import crateTrainedV3 from './img/optionsImages/crateTrainedV3.png';
import crateTrainedV4 from './img/optionsImages/crateTrainedV4.png';

import accidentsOftenV1 from './img/optionsImages/accidentsOftenV1.png';
import accidentsOftenV2 from './img/optionsImages/accidentsOftenV2.png';
import accidentsOftenV3 from './img/optionsImages/accidentsOftenV3.png';
import accidentsOftenV4 from './img/optionsImages/accidentsOftenV4.png';

import accidentsWhatDoV1 from './img/optionsImages/accidentsWhatDoV1.png';
import accidentsWhatDoV2 from './img/optionsImages/accidentsWhatDoV2.png';
import accidentsWhatDoV3 from './img/optionsImages/accidentsWhatDoV3.png';
import accidentsWhatDoV4 from './img/optionsImages/accidentsWhatDoV4.png';

import concernToiletTrainingV1 from './img/optionsImages/concernToiletTrainingV1.png';
import concernToiletTrainingV2 from './img/optionsImages/concernToiletTrainingV2.png';
import concernToiletTrainingV3 from './img/optionsImages/concernToiletTrainingV3.png';
import concernToiletTrainingV4 from './img/optionsImages/concernToiletTrainingV4.png';

import puppyChewV1 from './img/optionsImages/puppyChewV1.png';
import puppyChewV2 from './img/optionsImages/puppyChewV2.png';
import puppyChewV3 from './img/optionsImages/puppyChewV3.png';
import puppyChewV4 from './img/optionsImages/puppyChewV4.png';
import puppyChewV5 from './img/optionsImages/puppyChewV5.png';

import puppyBiteHandsV1 from './img/optionsImages/puppyBiteHandsV1.png';
import puppyBiteHandsV2 from './img/optionsImages/puppyBiteHandsV2.png';
import puppyBiteHandsV3 from './img/optionsImages/puppyBiteHandsV3.png';
import puppyBiteHandsV4 from './img/optionsImages/puppyBiteHandsV4.png';

import puppyLeaveHouseV1 from './img/optionsImages/puppyLeaveHouseV1.png';
import puppyLeaveHouseV2 from './img/optionsImages/puppyLeaveHouseV2.png';
import puppyLeaveHouseV3 from './img/optionsImages/puppyLeaveHouseV3.png';
import puppyLeaveHouseV4 from './img/optionsImages/puppyLeaveHouseV4.png';

import fixBehaviorIssuesV1 from './img/optionsImages/fixBehaviorIssuesV1.png';
import fixBehaviorIssuesV2 from './img/optionsImages/fixBehaviorIssuesV2.png';
import fixBehaviorIssuesV3 from './img/optionsImages/fixBehaviorIssuesV3.png';
import fixBehaviorIssuesV4 from './img/optionsImages/fixBehaviorIssuesV4.png';
import fixBehaviorIssuesV5 from './img/optionsImages/fixBehaviorIssuesV5.png';

import understandingV1 from './img/optionsImages/understandingV1.png';
import understandingV2 from './img/optionsImages/understandingV2.png';
import understandingV3 from './img/optionsImages/understandingV3.png';
import understandingV4 from './img/optionsImages/understandingV4.png';

import puppyFeelingsV1 from './img/optionsImages/puppyFeelingsV1.png';
import puppyFeelingsV2 from './img/optionsImages/puppyFeelingsV2.png';
import puppyFeelingsV3 from './img/optionsImages/puppyFeelingsV3.png';
import puppyFeelingsV4 from './img/optionsImages/puppyFeelingsV4.png';

import gettingPuppyMistakeV1 from './img/optionsImages/gettingPuppyMistakeV1.svg';
import gettingPuppyMistakeV2 from './img/optionsImages/gettingPuppyMistakeV2.svg';
import gettingPuppyMistakeV3 from './img/optionsImages/gettingPuppyMistakeV3.svg';
import gettingPuppyMistakeV4 from './img/optionsImages/gettingPuppyMistakeV4.svg';

import notEnjoyLifeWithDogV1 from './img/optionsImages/notEnjoyLifeWithDogV1.svg';
import notEnjoyLifeWithDogV2 from './img/optionsImages/notEnjoyLifeWithDogV2.svg';
import notEnjoyLifeWithDogV3 from './img/optionsImages/notEnjoyLifeWithDogV3.svg';
import notEnjoyLifeWithDogV4 from './img/optionsImages/notEnjoyLifeWithDogV4.svg';

import puppyChallengesV1 from './img/optionsImages/puppyChallengesV1.png';
import puppyChallengesV2 from './img/optionsImages/puppyChallengesV2.png';
import puppyChallengesV3 from './img/optionsImages/puppyChallengesV3.png';
import puppyChallengesV4 from './img/optionsImages/puppyChallengesV4.png';
import puppyChallengesV5 from './img/optionsImages/puppyChallengesV5.png';

import appetiteV1 from './img/optionsImages/understandingV1.png';
import appetiteV2 from './img/optionsImages/appetiteV2.png';
import appetiteV3 from './img/optionsImages/appetiteV3.png';
import appetiteV4 from './img/optionsImages/appetiteV4.png';

import understandingWhenV3 from './img/optionsImages/understandingWhenV3.png';

import customV2PlayFrequencyV1 from './img/optionsImages/customV2PlayFrequencyV1.svg';
import customV2PlayFrequencyV2 from './img/optionsImages/customV2PlayFrequencyV2.svg';
import customV2PlayFrequencyV3 from './img/optionsImages/customV2PlayFrequencyV3.png';
import customV2PlayFrequencyV4 from './img/optionsImages/customV2PlayFrequencyV4.svg';

import customV2PlayGamesV1 from './img/optionsImages/customV2PlayGamesV1.svg';
import customV2PlayGamesV2 from './img/optionsImages/customV2PlayGamesV2.svg';
import customV2PlayGamesV3 from './img/optionsImages/customV2PlayGamesV3.svg';
import customV2PlayGamesV4 from './img/optionsImages/customV2PlayGamesV4.svg';
// import customV2PlayGamesV5 from './img/optionsImages/customV2PlayGamesV5.svg';

import customV2PlayBehaviorV1 from './img/optionsImages/customV2PlayBehaviorV1.svg';
import customV2PlayBehaviorV2 from './img/optionsImages/customV2PlayBehaviorV2.svg';
import customV2PlayBehaviorV3 from './img/optionsImages/customV2PlayBehaviorV3.svg';
import customV2PlayBehaviorV4 from './img/optionsImages/customV2PlayBehaviorV4.svg';
import customV2PlayBehaviorV5 from './img/optionsImages/customV2PlayBehaviorV5.svg';

import customV2PlayIdeasV1 from './img/optionsImages/customV2PlayIdeasV1.png';
import customV2PlayIdeasV2 from './img/optionsImages/customV2PlayIdeasV2.svg';
import customV2PlayIdeasV3 from './img/optionsImages/customV2PlayIdeasV3.svg';
import customV2PlayIdeasV4 from './img/optionsImages/customV2PlayIdeasV4.svg';

// import stop from './img/optionsImages/stop.svg';
import stopV2 from './img/optionsImages/stop.png';
import blood from './img/optionsImages/blood.png';
import constipation from './img/optionsImages/constipation.png';
import dogV1 from './img/optionsImages/dogV1.png';
import dogV2 from './img/optionsImages/dogV2.png';
import storm from './img/optionsImages/storm.png';
import trash from './img/optionsImages/trash.png';
import houseV1 from './img/optionsImages/houseV1.png';
import foodV5 from './img/optionsImages/foodV5.png';
import upAndDown from './img/optionsImages/upAndDown.png';
import tornado from './img/optionsImages/tornado.png';
import dream from './img/optionsImages/dream.png';
import target from './img/optionsImages/target.png';
import selection from './img/optionsImages/selection.png';
import attention from './img/optionsImages/attention.png';
import checkmark from './img/optionsImages/checkmark.png';
import checkmarkV1 from './img/optionsImages/checkmarkV1.png';
import checkmarkV2 from './img/optionsImages/checkmarkV2.png';
import checkmarkV3 from './img/optionsImages/checkmarkV3.png';
import checkmarkV4 from './img/optionsImages/checkmarkV4.png';
import pill from './img/optionsImages/pill.png';
import pillClock from './img/optionsImages/pillClock.png';
import google from './img/optionsImages/google.png';
import eating from './img/optionsImages/eating.png';

const darkTheme = getParameterFromURL('darkTheme') === 'true';
const currentConfig = getParameterFromURL('config');
const { vetOnboarding } = store.getState().steps;
const startPageAgeVet = vetOnboarding;
const startPageAgeVar3 = currentConfig === 'customV48';
const startPageAgeVar4 = currentConfig === 'customV67' || currentConfig === 'customV68';

const startPageAgeImages = (() => {
  if (startPageAgeVet) {
    return {
      v1: startPageAgeV1Vet,
      v2: startPageAgeV2Vet,
      v3: startPageAgeV3Vet,
      v4: startPageAgeV4Vet,
    };
  }

  if (startPageAgeVar3) {
    return {
      v1: startPageAgeV3V1,
      v2: startPageAgeV3V2,
      v3: startPageAgeV3V3,
      v4: startPageAgeV3V4,
    };
  }

  if (startPageAgeVar4) {
    return {
      v1: startPageAgeV1Ilustr,
      v2: startPageAgeV2Ilustr,
      v3: startPageAgeV3Ilustr,
      v4: startPageAgeV4Ilustr,
    };
  }

  return {
    v1: startPageAgeV1,
    v2: startPageAgeV2,
    v3: startPageAgeV3,
    v4: startPageAgeV4,
  };
})();

const optionsImages = {
  age: {
    puppy: iconPuppy,
    adult: iconAdult,
  },
  role: {
    puppy: iconPuppy,
    dog: iconAdult,
    wannabe: iconSmile,
  },
  puppy_or_adult: {
    puppy: iconPuppy,
    adult: iconAdult,
    skip: iconCross,
  },
  how_old: {
    zero: iconPuppy,
    six: iconPuppy,
    year: iconAdult,
    two_years: iconPoodle,
    five_years: iconDarkDog,
    dont_know: iconDontKnow,
    skip: iconCross,
  },
  breed: {
    dont_know: iconDontKnow,
    skip: iconCross,
  },
  dog_name: {
    skip: iconCross,
  },
  goal: {
    other: iconOther,
    teaching_puppy: iconPoodle,
    surviving_puppy: iconChick,
    socializing_puppy: iconLabrador,
    teaching_obedience: iconAdult,
    correcting_behavior: iconPuppy,
    getting_shape: iconBone,
    rasing_adopted_dog: iconHeart,
    playing_with_pooch: iconBall,
  },
  biting: {
    yes: iconSurprised,
    no: iconSmile,
    sometimes: iconPensive,
  },
  potty_training: {
    yes: iconSmile,
    no: iconSurprised,
    a_bit: iconPensive,
  },
  commands: {
    sit: iconPoodle,
    wait: iconLabrador,
    stay: iconAdult,
    place: iconPuppy,
    down: iconDown,
    leave_it: iconBone,
    come: iconPaws,
  },
  commands_puppy: {
    sit: iconPoodle,
    wait: iconLabrador,
    stay: iconAdult,
    place: iconPuppy,
    down: iconDown,
    leave_it: iconBone,
    come: iconPaws,
  },
  being_home_alone: {
    yes: iconSmile,
    no: iconSurprised,
    short_period: iconUpset,
  },
  being_home_alone_puppy: {
    yes: iconSmile,
    no: iconSurprised,
    it_varies: iconUpset,
  },
  hygiene: {
    yes: iconSmile,
    no: iconSurprised,
    only_with_some: iconUpset,
  },
  chewing: {
    yes: iconSmile,
    no: iconSurprised,
    sometimes: iconUpset,
  },
  jumping_on_people: {
    yes: iconSurprised,
    no: iconSmile,
    sometimes: iconPensive,
  },
  being_for_food: {
    yes: iconSurprised,
    no: iconSmile,
    sometimes: iconUpset,
  },
  obedience: {
    yes: iconSurprised,
    no: iconSmile,
    fifty_fifty: iconUpset,
  },
  picking_up_from_the_ground: {
    yes: iconSurprised,
    no: iconSmile,
    sometimes: iconUpset,
  },
  additional_picture: {
    age: addImgAge,
    jumping_on_people: addImgJumping,
    obedience: addImgObedience,
    picking_up_from_the_ground: addImgPickingUp,
    being_for_food: addImgBeingForFood,
    puppy_or_adult: addImgPuppyOrAdult,
    how_old: addImgHowOld,
    breed: addImgBreed,
    biting: addImgBiting,
    chewing: addImgChewing,
    being_home_alone: addImgBeingHome,
    being_home_alone_puppy: addImgBeingHome,
    hygiene: addImgHygiene,
    potty_training: addImgPottyTraining,
  },

  customV1_gender: {
    girl: iconGenderGirl,
    boy: iconGenderBoy,
  },
  customV1_age: {
  },
  customV1_breed: {
  },
  customV1_commands: {
  },
  customV1_descriptionV1: {
  },
  customV1_startPage: {
  },
  customV1_nervous: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_anxious: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_stressed: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_being_home_alone: {
    v1: iconBeingHomeAloneV1,
    v2: iconBeingHomeAloneV2,
    v3: iconBeingHomeAloneV3,
    v4: iconBeingHomeAloneV4,
  },
  customV1_walk: {
  },
  customV1_hygiene: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_concern: {
  },
  customV1_dangerous_situation: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_these_commands: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_eat_something_bad: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_this_command: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_afraid: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_descriptionV2: {
  },
  customV1_when_called: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_when_chews: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_boundaries: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_hard_training: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_main_goal: {
  },
  customV1_training_time: {
  },

  customV2_startPage: {},
  customV2_startPageV2: {},
  customV2_startPageV3: {},
  customV2_startPageV4: {},
  customV2_startPageV5: {},
  customV2_startPageV6: {},
  customV2_startPageV7: {},
  customV2_startPageV8: {},
  customV2_startPageV11: {},
  customV2_startPageV12: {},
  customV2_startPageV13: {},
  customV2_startPageV17: {},
  customV2_startPageV18: {},
  customV2_startPageV19: {},
  customV2_startPageV20: {},
  customV2_startPageV21: {},
  customV2_startPageV22: {},
  customV2_startPageV23: {},
  customV2_startPageV24: {},
  customV2_startPageV25: {},
  customV2_startPageV26: {},
  customV2_startPageV27: {},
  customV2_startPageV28: {},
  customV2_startPageV29: {},
  customV2_startPageV30: {},
  customV2_startPageV31: {},
  customV2_startPageV32: {},
  customV2_startPageV33: {},
  customV2_startPageV41: {},
  customV2_startPageV34: {},
  customV2_startPageV35: {},
  customV2_startPageV42: {},
  customV2_startPageV43: {},
  customV2_startPageV37: {},
  customV2_startPageV44: {},
  customV2_policyPage: {},
  customV2_policyPageV2: {},
  customV2_policyPageV3: {},
  customV2_policyPageV4: {},
  customV2_policyPageV5: {},
  customV2_policyPageV6: {},
  customV2_videoPolicyPage: {},
  customV2_start_page_video: {},
  customV2_start_page_video_v2: {},
  customV2_gender: {
    v1: iconGenderGirlV2,
    v2: iconGenderBoyV2,
  },
  customV2_name: {},
  customV2_puppy_feelings: {
    v1: puppyFeelingsV1,
    v2: puppyFeelingsV2,
    v3: puppyFeelingsV3,
    v4: puppyFeelingsV4,
  },
  getting_puppy_mistake: {
    v1: gettingPuppyMistakeV1,
    v2: gettingPuppyMistakeV2,
    v3: gettingPuppyMistakeV3,
    v4: gettingPuppyMistakeV4,
  },
  customV2_puppy_challenges: {
    v1: puppyChallengesV1,
    v2: puppyChallengesV2,
    v3: puppyChallengesV3,
    v4: puppyChallengesV4,
    v5: puppyChallengesV5,
  },
  not_enjoy_life_with_dog: {
    v1: notEnjoyLifeWithDogV1,
    v2: notEnjoyLifeWithDogV2,
    v3: notEnjoyLifeWithDogV3,
    v4: notEnjoyLifeWithDogV4,
  },
  customV2_drinking: {
    v1: customV2DrinkingV1,
    v2: customV2DrinkingV2,
    v3: customV2DrinkingV3,
    v4: customV2DrinkingV4,
  },
  customV2_appetite: {
    v1: appetiteV1,
    v2: appetiteV2,
    v3: appetiteV3,
    v4: appetiteV4,
  },
  customV2_stool_changes: {
    v1: customV2HealthHandOk,
    v2: customV2HealthStackedBox,
    v3: constipation,
    v4: blood,
    v5: customV2HealthUnsure,
  },
  customV2_pain_signs: {
    v1: customV2HealthHandOk,
    v2: dogV1,
    v3: dogV2,
    v4: storm,
  },
  customV2_recent_exposure: {
    v1: foodV5,
    v2: trash,
    v3: dogV1,
    v4: houseV1,
    v5: customV2HealthUnsure,
  },
  customV2_energy_level: {
    v1: dream,
    v2: upAndDown,
    v3: customV2HealthHandOk,
    v4: tornado,
  },
  customV2_scratching_licking: {
    v1: attention,
    v2: selection,
    v3: target,
    v4: customV2HealthHandOk,
  },
  customV2_chewing_biting: {
    v1: puppyBiteHandsV1,
    v2: puppyBiteHandsV2,
    v3: puppyBiteHandsV3,
    v4: puppyBiteHandsV4,
  },
  customV2_sleep_changes: {
    v1: dream,
    v2: puppyLeaveHouseV3,
    v3: iconPottyV2,
    v4: customV2HealthHandOk,
  },
  customV2_anxiety_restlessness: {
    v1: iconIssuesV3,
    v2: dogV2,
    v3: dogV1,
    v4: customV2HealthHandOk,
  },
  customV2_vaccination_status: {
    v1: checkmark,
    v2: checkmarkV1,
    v3: stopV2,
  },
  customV2_medication: {
    v1: checkmarkV1,
    v2: iconTrainingV1,
    v3: pill,
    v4: stopV2,
  },
  customV2_supplements: {
    v1: checkmarkV1,
    v2: pillClock,
    v3: customV2HealthAlert,
    v4: stopV2,
  },
  customV2_health_help_first: {
    v1: google,
    v2: iconWalkingIssuesV5,
    v3: customV2HealthEye,
    v4: iconTrainingV1,
  },
  customV2_health_worries: {
    v1: checkmarkV2,
    v2: customV2HealthSymptoms,
    v3: eating,
    v4: iconTrainingV3,
  },
  customV2_food_type: {
    v1: customV2FoodTypeV1,
    v2: customV2FoodTypeV2,
    v3: customV2FoodTypeV3,
    v4: customV2FoodTypeV4,
  },
  customV2_food_allergies: {
    v1: customV2FoodAllergiesV1,
    v2: customV2FoodAllergiesV2,
    v3: customV2FoodAllergiesV3,
    v4: customV2FoodAllergiesV4,
  },
  customV2_health_goals: {
    v1: customV2HealthGoalsV1,
    v2: customV2HealthGoalsV2,
    v3: customV2HealthGoalsV3,
    v4: customV2HealthGoalsV4,
  },
  customV2_food_choice: {
    v1: customV2FoodChoiceV1,
    v2: customV2FoodChoiceV2,
    v3: customV2FoodChoiceV3,
    v4: customV2FoodChoiceV4,
  },
  customV2_vet_access: {
    v1: customV2HealthAlert,
    v2: checkmarkV4,
    v3: checkmarkV3,
    v4: customV2HealthHandOk,
  },
  customV2_late_night_worry: {
    v1: customV2HealthAlert,
    v2: customV2HealthMoon,
    v3: customV2HealthUnsure,
  },
  customV2_first_dog: {
    v1: checkmark,
    v2: checkmarkV1,
  },
  customV2_age: {},
  customV2_breed: {},
  customV2_health: {
    v1: iconHealthV1,
    v2: iconHealthV2,
    v3: iconHealthV3,
    v4: iconHealthV4,
    v5: iconHealthV5,
  },
  customV2_potty: {
    v1: iconPottyV7,
    v2: iconPottyV8,
    v3: iconPottyV9,
    v4: iconPottyV10,
  },
  customV2_reason: {
    v1: customV2reasonV1,
    v2: customV2reasonV2,
    v3: customV2reasonV3,
    v4: customV2reasonV4,
    v5: customV2reasonV5,
    v6: customV2reasonV6,
    v7: customV2reasonV7,
    v8: customV2reasonV8,
  },
  customV2_date: {},
  customV2_issues: {
    v1: iconIssuesV1,
    v2: iconIssuesV2,
    v3: iconIssuesV3,
    v4: iconIssuesV4,
    v5: iconIssuesV5,
  },
  customV2_issues_2: {
    v1: iconIssues2V1,
    v2: iconIssues2V2,
    v3: iconIssues2V3,
    v4: iconIssues2V4,
    v5: iconIssues2V5,
    v6: iconIssues2V6,
  },
  customV2_walking_issues: {
    v1: iconWalkingIssuesV1,
    v2: iconWalkingIssuesV2,
    v3: iconWalkingIssuesV3,
    v4: iconWalkingIssuesV4,
    v5: iconWalkingIssuesV5,
  },
  customV2_activity: {
    v1: iconActivityV1,
    v2: iconActivityV2,
    v3: iconActivityV3,
  },
  age_group: {},
  customV2_training_time: {},
  customV2_training: {
    v1: iconTrainingV1,
    v2: iconTrainingV2,
    v3: iconTrainingV3,
  },
  customV2_command_1: {},
  customV2_command_2: {},
  customV2_command_3: {},
  customV2_command_4: {},
  customV2_info_health: {},
  info_about_food_scanner: {},
  customV2_info_puppy_easier: {},
  customV2_info_puppy_blues: {},
  customV2_info_breed: {},
  info_about_worries: {},
  info_about_nutrition: {},
  customV2_info_breed_2: {},
  customV2_info_breed_3: {},
  customV2_plan: {},
  customV2_info_predict: {},
  customV2_creating_program: {
    v1: iconCreatingProgramV5,
    v2: iconCreatingProgramV6,
    v3: iconCreatingProgramV7,
    v4: iconCreatingProgramV8,
  },

  customV3_gender: {
    v1: iconGenderGirlV2,
    v2: iconGenderBoyV2,
  },
  customV4_behavior_problem: {
    v1: behaviorProblemV1,
    v2: behaviorProblemV2,
    v3: behaviorProblemV3,
    v4: behaviorProblemV4,
  },

  customV2_age_v2: {
    v1: customV2ageV1,
    v2: customV2ageV2,
    v3: customV2ageV3,
    v4: customV2ageV4,
    v5: customV2ageV5,
    v6: customV2ageV6,
  },

  customV4_behavior_problem_v2: {
    v1: behaviorProblemV5,
    v2: behaviorProblemV6,
    v3: behaviorProblemV7,
    v4: behaviorProblemV8,
  },
  customV5_behavior_problem: {
    v1: behaviorV1,
    v2: behaviorV2,
    v3: behaviorV3,
    v4: behaviorV4,
    v5: behaviorV5,
    v6: behaviorV6,
    v7: behaviorV7,
  },
  customV2_food: {
    v1: foodV1,
    v2: foodV2,
    v3: foodV3,
    v4: foodV4,
  },
  issues_biting: {
    v1: issuesBitingV1,
    v2: issuesBitingV2,
  },
  issues_damage: {
    v1: issuesDamageV1,
    v2: issuesDamageV2,
  },
  issues_crate: {
    v1: issuesCrateV1,
    v2: issuesCrateV2,
  },
  issues_home: {
    v1: issuesHomeV1,
    v2: issuesHomeV2,
    v3: issuesHomeV3,
    v4: issuesHomeV4,
  },
  follow_commands: {
    v1: followCommandsV1,
    v2: followCommandsV2,
    v3: followCommandsV3,
    v4: followCommandsV4,
  },
  get_irritated: {
    v1: issuesHomeV2,
    v2: issuesHomeV3,
    v3: issuesHomeV4,
  },
  raise_voice: {
    v1: raiseVoiceV1,
    v2: raiseVoiceV2,
    v3: raiseVoiceV3,
    v4: raiseVoiceV4,
  },
  hit_dog: {
    v1: hitDogV1,
    v2: hitDogV2,
  },
  how_attached: {
    v1: howAttachedV1,
    v2: howAttachedV2,
    v3: howAttachedV3,
  },
  info_thank: {},
  owner_feelings: {
    v1: ownerFeelingsV1,
    v2: ownerFeelingsV2,
    v3: ownerFeelingsV3,
    v4: ownerFeelingsV4,
  },
  owner_sleep: {
    v1: ownerSleepV1,
    v2: ownerSleepV2,
    v3: ownerSleepV3,
    v4: ownerSleepV4,
  },
  owner_puppy_behavior: {
    v1: ownerFeelingsV1,
    v2: ownerFeelingsV2,
    v3: ownerFeelingsV3,
    v4: ownerFeelingsV4,
  },
  owner_puppy_managing: {
    v1: ownerFeelingsV1,
    v2: ownerFeelingsV2,
    v3: ownerFeelingsV3,
    v4: ownerFeelingsV4,
  },
  owner_puppy_affect: {
    v1: ownerPuppyAffectV1,
    v2: ownerPuppyAffectV2,
    v3: ownerPuppyAffectV3,
    v4: ownerPuppyAffectV4,
  },
  owner_support: {
    v1: ownerSupportV1,
    v2: ownerSupportV2,
    v3: ownerSupportV3,
    v4: ownerSupportV4,
  },
  owner_concerns: {
    v1: ownerConcernsV1,
    v2: ownerConcernsV2,
    v3: ownerConcernsV3,
    v4: ownerConcernsV4,
    v5: ownerConcernsV5,
  },
  info_about_owner: {},
  customV2_potty_v2: {
    v1: iconPottyV1,
    v2: iconPottyV2,
    v3: iconPottyV3,
    v4: iconPottyV5,
    v5: iconPottyV6,
    v6: iconPottyV4,
  },
  potty_how_long: {
    v1: pottyHowLongV1,
    v2: pottyHowLongV2,
  },
  potty_where: {
    v1: pottyWhereV1,
    v2: pottyWhereV1,
  },
  potty_how_often_walks: {
    v1: pottyHowOftenWalksV1,
    v2: pottyHowOftenWalksV1,
  },
  potty_health_issues: {
    v1: pottyHealthIssuesV1,
    v2: pottyHealthIssuesV2,
    v3: pottyHealthIssuesV3,
    v4: pottyHealthIssuesV4,
  },
  potty_where_want: {
    v1: pottyWhereWantV1,
    v2: pottyWhereWantV2,
    v3: pottyWhereWantV3,
    v4: pottyHealthIssuesV4,
  },
  training_raise_voice: {
    v1: trainingRaiseVoiceV1,
    v2: trainingRaiseVoiceV2,
    v3: trainingRaiseVoiceV3,
    v4: trainingRaiseVoiceV4,
  },
  training_react_to_punishment: {
    v1: trainingReactToPunishmentV1,
    v2: trainingReactToPunishmentV2,
    v3: trainingReactToPunishmentV3,
    v4: trainingReactToPunishmentV4,
  },
  statement_irritation: {
    v1: darkTheme ? statementIrritationV1Dark : statementIrritationV1,
  },
  statement_ignore_commands: {
    v1: darkTheme ? statementIgnoreCommandsV1Dark : statementIgnoreCommandsV1,
  },
  health_uncertainty: {
    v1: healthUncertainty,
  },
  statement_strong_bond: {
    v1: darkTheme ? statementStrongBondV1Dark : statementStrongBondV1,
  },
  statement_enjoy_time: {
    v1: darkTheme ? statementStrongBondV1Dark : statementStrongBondV1,
  },
  customV2_startPageGender: {
    v1: iconGenderGirlV3,
    v2: iconGenderBoyV3,
  },
  customV2_quote: {},
  main_goal: {
    v1: mainGoalV1,
    v2: mainGoalV2,
    v3: mainGoalV3,
    v4: mainGoalV4,
    v5: mainGoalV5,
  },
  gender_zw: {
    v1: zwGirl,
    v2: zwBoy,
  },
  zw_age: {
    v1: wo1,
    v2: wo2,
    v3: wo3,
    v4: wo4,
    v5: wo5,
  },
  start_page_age: {
    v1: startPageAgeImages.v1,
    v2: startPageAgeImages.v2,
    v3: startPageAgeImages.v3,
    v4: startPageAgeImages.v4,
  },
  start_page_age_v2: {
    v1: startPageAgeV2V1,
    v2: startPageAgeV2V2,
    v3: startPageAgeV2V3,
    v4: startPageAgeV2V4,
  },
  start_page_age_v3: {
    v1: startPageAgeV1,
    v2: startPageAgeV2,
    v3: startPageAgeV3,
    v4: startPageAgeV4,
  },
  training_time: {
    v1: trainingTimeV1,
    v2: trainingTimeV2,
    v3: trainingTimeV3,
    v4: trainingTimeV4,
  },
  crate_trained: {
    v1: crateTrainedV1,
    v2: crateTrainedV2,
    v3: crateTrainedV3,
    v4: crateTrainedV4,
  },
  accidents_how_often: {
    v1: accidentsOftenV1,
    v2: accidentsOftenV2,
    v3: accidentsOftenV3,
    v4: accidentsOftenV4,
  },
  info_about_crate: {},
  accidents_what_do: {
    v1: accidentsWhatDoV1,
    v2: accidentsWhatDoV2,
    v3: accidentsWhatDoV3,
    v4: accidentsWhatDoV4,
  },
  concern_toilet_training: {
    v1: concernToiletTrainingV1,
    v2: concernToiletTrainingV2,
    v3: concernToiletTrainingV3,
    v4: concernToiletTrainingV4,
  },
  info_about_potty_struggles: {},
  behavior_signals: {},
  puppy_issues_at_home: {
    v1: iconIssuesV2,
    v2: iconIssuesV3,
    v3: iconIssuesV4,
    v4: iconIssuesV5,
  },
  puppy_chew: {
    v1: puppyChewV1,
    v2: puppyChewV2,
    v3: puppyChewV3,
    v4: puppyChewV4,
    v5: puppyChewV5,
  },
  puppy_bite_hands: {
    v1: puppyBiteHandsV1,
    v2: puppyBiteHandsV2,
    v3: puppyBiteHandsV3,
    v4: puppyBiteHandsV4,
  },
  puppy_leave_house: {
    v1: puppyLeaveHouseV1,
    v2: puppyLeaveHouseV2,
    v3: puppyLeaveHouseV3,
    v4: puppyLeaveHouseV4,
  },
  fix_behavior_issues: {
    v1: fixBehaviorIssuesV1,
    v2: fixBehaviorIssuesV2,
    v3: fixBehaviorIssuesV3,
    v4: fixBehaviorIssuesV4,
    v5: fixBehaviorIssuesV5,
  },
  info_about_training: {},
  puppy_commands: {},
  first_puppy: {},
  understanding: {
    v1: understandingV1,
    v2: understandingV2,
    v3: understandingV3,
    v4: understandingV4,
  },
  info_about_understanding: {},
  understanding_when: {
    v1: iconIssuesV3,
    v2: concernToiletTrainingV2,
    v3: howAttachedV1,
    v4: understandingWhenV3,
  },
  understanding_real_time: {
    v1: iconPottyV10,
    v2: iconIssuesV3,
    v3: iconCreatingProgramV6,
    v4: stopV2,
  },
  customV2_play_frequency: {
    v1: customV2PlayFrequencyV1,
    v2: customV2PlayFrequencyV2,
    v3: customV2PlayFrequencyV3,
    v4: customV2PlayFrequencyV4,
  },
  customV2_play_games: {
    v1: customV2PlayGamesV1,
    v2: customV2PlayGamesV2,
    v3: customV2PlayGamesV3,
    v4: customV2PlayGamesV4,
    v5: stopV2,
  },
  customV2_play_behavior: {
    v1: customV2PlayBehaviorV1,
    v2: customV2PlayBehaviorV2,
    v3: customV2PlayBehaviorV3,
    v4: customV2PlayBehaviorV4,
    v5: customV2PlayBehaviorV5,
  },
  customV2_play_ideas: {
    v1: customV2PlayIdeasV1,
    v2: customV2PlayIdeasV2,
    v3: customV2PlayIdeasV3,
    v4: customV2PlayIdeasV4,
  },
  understanding_summary: {},
};

export default optionsImages;
